import { TrendingUp, TrendingDown, BarChart3, Layers } from "lucide-react";
import { fmtCompact, fmtSigned, signClass } from "@/lib/format";

const Card = ({ label, value, sub, subCls = "", icon: Icon, testid }) => (
  <div
    className="border border-zinc-800 bg-[#09090B] p-3 hover:border-zinc-600 transition-colors duration-75"
    data-testid={testid}
  >
    <div className="flex items-center justify-between mb-1.5">
      <span className="text-[11px] uppercase tracking-widest text-zinc-500">{label}</span>
      {Icon && <Icon size={14} strokeWidth={1.5} className="text-zinc-600" />}
    </div>
    <div className="text-xl font-semibold text-zinc-100 tabular-nums leading-none">{value}</div>
    {sub && <div className={`text-[11px] mt-1.5 tabular-nums ${subCls}`}>{sub}</div>}
  </div>
);

const Skeleton = () => (
  <div className="border border-zinc-800 bg-[#09090B] p-3 h-[88px] animate-pulse" />
);

export default function SummaryCards({ summary, loading, sidebar = false }) {
  const wrap = sidebar
    ? "grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-1 gap-3"
    : "grid grid-cols-2 md:grid-cols-4 gap-3";
  if (loading || !summary) {
    return (
      <div className={wrap} data-testid="summary-cards-loading">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className={wrap} data-testid="summary-cards">
      <Card
        testid="card-total-oi"
        label="Total Open Interest"
        value={fmtCompact(summary.total_open_interest)}
        icon={Layers}
        sub={`${fmtSigned(summary.total_change_oi)} WoW`}
        subCls={signClass(summary.total_change_oi)}
      />
      <Card
        testid="card-net-noncomm"
        label="Sum Net Non-Comm"
        value={fmtSigned(summary.net_noncomm_sum)}
        icon={BarChart3}
        sub={`${summary.markets_count} markets aggregated`}
        subCls="text-zinc-500"
      />
      <Card
        testid="card-most-bullish"
        label="Most Bullish (Non-Comm)"
        value={summary.most_bullish?.symbol || "—"}
        icon={TrendingUp}
        sub={
          summary.most_bullish
            ? `${fmtSigned(summary.most_bullish.net_noncomm)} · ${summary.most_bullish.name}`
            : "—"
        }
        subCls="text-pos"
      />
      <Card
        testid="card-most-bearish"
        label="Most Bearish (Non-Comm)"
        value={summary.most_bearish?.symbol || "—"}
        icon={TrendingDown}
        sub={
          summary.most_bearish
            ? `${fmtSigned(summary.most_bearish.net_noncomm)} · ${summary.most_bearish.name}`
            : "—"
        }
        subCls="text-neg"
      />
    </div>
  );
}
